export default __webpack_public_path__ + "static/anypayload-439fb89e0c86d886a8b19de77f687734.png";